var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.AbstractModel = new Class({
    Implements: [Options, Events],
    class_name: "AbstractModel",
    class_type: "Model",
    ready: false,
    stages: ["pre_process", "process", "post_process"],
    active_stage: 0,
    options: {
        layer_types: ['advisory', 'contour', 'distance', 'gradient', 'gridlines', 'image', 'obs', 'radar', 'shape', 'symbol', 'vector', 'kmz'],
        animatable_layer_types: ['advisory', 'contour', 'distance', 'gradient', 'gridlines', 'obs', 'radar', 'vector'],
        map: {},
        auto_start_process: true
    },
    map_object: {
        layers: [],
        map: {},
        radar: {       
            product: "N0B",
            site: "KTLX"
        }
    },
    map_datetime: null,
    input: null,
    initialize: function (input, options) {
        this.input = input;
        if (options) {
            this.setOptions(options);
        }
        this.start_process_ev = new OCS.Classes.OCSEvent({"event_name": "start_process", callback: this.on_start_process.bind(this), "specific_event": true});
        this.ready_ev = new OCS.Classes.OCSEvent({"event_name": "ready", callback: this.on_ready.bind(this), "specific_event": true});
        this.stage_complete_ev = new OCS.Classes.OCSEvent({"event_name": "stage_complete", callback: this.on_stage_complete.bind(this), "specific_event": true});

        if (this.options.auto_start_process && this.input) {
            this.start_process_ev.event('start_process', this, 1);
        }
    },

    on_start_process: function () {
        this.active_stage = -1;
        this.on_stage_complete();
    },
    on_stage_complete: function () {
        this.active_stage++;
        if (this.stages[this.active_stage]) {
            if (this[this.stages[this.active_stage]]) {
                this[this.stages[this.active_stage]]();
            }
        } else {
            // We did not have a method for this, proceeding forward
            if (this.active_stage > this.stages.length) {
                this.ready_ev.event('ready', this, 1);
            } else {
                this.on_stage_complete();
            }
        }
    },
    pre_process: function () {
        this.stage_complete_ev.event('stage_complete', this, 1);
    },
    process: function () {
        this.stage_complete_ev.event('stage_complete', this, 1);
    },
    post_process: function () {
        this.stage_complete_ev.event('stage_complete', this, 1);
    },
    get_map_datetime: function () {
        if (!this.map_datetime) {
            this.map_datetime = new OCS.Viewer.Classes.MapDateTime({debug: this.options.debug});
        }
        return this.map_datetime;
    },
    get_map_layers: function() {
        return this.map_object.layers;
    },
    get_map_settings: function() {
        return this.map_object.map;
    },
    get_map_radar_settings: function() {
        return this.map_object.radar;
    },
    set_radar_site: function(site) {
        this.map_object.radar.site = site;
        this.fireEvent('change', [{'radar_site': site}, this]);
    },
    set_radar_product: function(prod) {
        this.map_object.radar.product = prod;
        this.fireEvent('change', [{'radar_product': prod}, this]);
    },
    /**
     * 
     * @param {String} type - String of the layer type to check if exist in the map definition
     * @returns {Boolean}
     */
    contains_layer: function (type) {
        return OCS.Viewer.Functions.get_utilities().array_has_object_with_prop(this.get_map_layers(), {'type': type});
    },
    /**
     * Checks to see if the map contains a radar layer
     */
    contains_radar_layer: function () {
        return this.contains_layer('radar');
    },
    /**
     * Checks to see if the map contains an advisory layer
     */
    contains_advisory_layer: function () {
        return this.contains_layer('advisory');
    },

    /**
     * Checks to see if the map contain a lightning layer
     */
    contains_lightning_layer: function () {
        return this.contains_layer('lightning');
    },
    get_layer: function(type) {
        var layer = this.contains_layer(type);
        if(layer && layer) {
            return layer;
        }
        return false;
    },

    

    /**
     * Checks if the map has at least one animatable layer
     */
    is_map_animatable: function () {
        return OCS.Viewer.Functions.get_utilities().array_has_object_with_cond(this.get_map_layers(), function (layer) {
            return this.options.animatable_layer_types.contains(layer.type);
        }.bind(this));
    },
    is_valid_layer_type: function (layer_type) {
        return this.options.layer_types.contains(layer_type);
    },
    on_ready: function () {       
        this.ready = true;
        this.fireEvent('is_ready', this);
    },
    destroy: function () {     
        this.input = null;
        this.start_process_ev.destroy();
        this.ready_ev.destroy();
        this.stage_complete_ev.destroy();
        if(this.map_datetime) {
            this.map_datetime.destroy();
            this.map_datetime = null;
        }
        this.removeEvents();
    },
}); // End OCS.Viewer.Classes.AbstractModel
